import { useStoreActions } from '~/contexts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { ErrorResponse } from '~/infra/error-response/ErrorResponse';
const MAX_RETRY_DELAY_MS = 8000;
export const useRegisterMobileNotification = ()=>{
    const { api } = useStoreActions();
    const { mutate, isLoading, isError } = useMutationState({
        mutationFn: (info)=>api.mobileNotification.register(info),
        retry: (failureCount, error)=>failureCount < 3 && new ErrorResponse(error).isTransient(),
        retryDelay: (attempt)=>Math.min(1000 * 2 ** attempt, MAX_RETRY_DELAY_MS)
    });
    return {
        registerMobileNotification: mutate,
        isLoading,
        isError
    };
};
